import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-gatorz-support.js';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import accordionPrimary from '../../../views/website/products/components/description/ui-modules/accordion-primary/raw-html.js';

const defaultLinks = [
  { label: 'Bulk Order', url: '', openInNewTab: true },
  { label: 'Replacement Nosepiece', url: '', openInNewTab: true },
  { label: 'Contact Us', url: '', openInNewTab: true },
  { label: 'Warranty', url: '', openInNewTab: true },
  { label: 'Adjustability Video', url: '', openInNewTab: true },
];

const renderLinkItem = item => {
  const url = (item.url || '').trim();
  const href = url || 'javascript:void(0)';
  const targetAttr = item.openInNewTab && url ? ' target="_blank" rel="noopener noreferrer"' : '';

  return `
    <a
      class="gatorz-support__link"
      data-attribute="gatorz-support__link-item"
      data-url="${url}"
      data-open-new-tab="${item.openInNewTab ? 'true' : 'false'}"
      href="${href}"${targetAttr}
    >${item.label || ''}</a>`;
};

const accordionContentHtml = `
  <div class="accordion-collapsible-body" data-attribute="accordion-collapsible-body">
    <div class="accordion-collapsible-body__inner">
      <nav class="gatorz-support__links" data-attribute="gatorz-support__links">
        ${defaultLinks.map(renderLinkItem).join('')}
      </nav>
    </div>
  </div>
`;

const accordionPrimaryHtml = accordionPrimary(accordionContentHtml, {
  open: false,
  title: '<h2><strong>SUPPORT</strong></h2>',
  backgroundColor: '#ffffff',
  color: '#000000',
  icon: {
    type: 'plus-minus',
    position: 'right',
    show: true,
  },
});

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 9999,
  height: 3,
  align: 'center',
  backgroundColor: '#C3C3C3',
});

const contentHtml = `
  <div class="container">
    <div class="wrap-gatorz-support" data-attribute="gatorz-support-content">
      ${accordionPrimaryHtml}
      ${dividerPrimaryHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: false,
  bottomPadding: false,
});
